import React, {Suspense} from 'react';
import Loader from './loader';
import WebFont from 'webfontloader';
import TopMenu from './menu/';
import ImpactQuote from './quote/';
import Footer from './footer/';
import Tabs from './portfolio/Tabs/';
const Portfolio = React.lazy(()=> import('./portfolio/'));


WebFont.load({
  google: {
    families: ['Fjalla One', 'Arima Madurai','sans-serif']
  }
});

function App() {
  return (
    <div>
      <header>
        <TopMenu />
        <ImpactQuote />
      </header>
      <section style={{marginTop:95}}>
        <Tabs />
      </section>
      <section>
        <Suspense fallback={<Loader />} >
          <Portfolio />
        </Suspense>
      </section>
      <section style={{marginTop:155}}>
        <Footer />
      </section>
    </div>
  );
}

export default App;
